/**
 * Scripts for WePlanet Engaging Networks templates
 */

declare global {
  interface Window {
    changeFieldErrorMessage: (
      identifier: 'fieldName' | 'specialValidator',
      identifierValue: string,
      newErrorMessage: string,
    ) => void;
    EngagingNetworks: {
      validators: ENValidator[];
    };
    onENValidateCustomValidationArray?: Array<() => void>;
    enVGSFields?: Record<string, { css: Record<string, string | Record<string, string>> }>;
    getStoredFieldValue: (fieldName: string) => string | undefined;
    jQuery?: (selector: string) => {
      animate: (properties: Record<string, number>, duration: number) => void;
    };
    onENValidateSetupCompleteArray: Array<() => void>;
    pageJson: { campaignId: number; locale: string; pageType: ENActionType };
  }
}

import { backgroundImage } from './scripts/background';
import {
  autoSetCurrencyField,
  selectDefaultDonationAmountOnCurrencyChange,
  syncDonationAmountLabelsWithCurrency,
} from './scripts/currency';
import {
  autoFocusDonationAmountInput,
  autoSelectOtherDonationAmountRadio,
  showDonationFrequencyOnSubmitButton,
  syncDonationAmountErrorState,
  syncDonationAmountOtherBackdrop,
  vgsCardFieldStyles,
} from './scripts/donations';
import { mpThumbnails } from './scripts/email-to-target';
import {
  customiseErrorMessages,
  mobileFloatingSkipToFormButton,
  sideBySideElements,
} from './scripts/forms';
import { addFlagEmojiToCountryOptions, autoSetCountryField } from './scripts/geo';
import { validatePostcodeForCountry } from './scripts/postcode';
import { addChildrenCountDataAttributeToRows } from './scripts/rows-columns';
import { shareButtons } from './scripts/share';
import { ENActionType } from './scripts/types/en-action-type';
import { ENValidator } from './scripts/types/en-validator';
import {
  shortenLongValidationMessages,
  stripHtmlFromValidationMessages,
} from './scripts/validation';

// Import styles so they are included in the build
import './styles/main.scss';

// Run immediately - function checks whether page has loaded and if not, it will run again until it finds the background image settings or page finishes loading
backgroundImage();

// Run immediately - functional code will actually run when ENvalidate setup is complete
stripHtmlFromValidationMessages();
shortenLongValidationMessages();

// Functions that run on page load
document.addEventListener('DOMContentLoaded', () => {
  addChildrenCountDataAttributeToRows();
  addFlagEmojiToCountryOptions();
  autoFocusDonationAmountInput();
  autoSelectOtherDonationAmountRadio();
  autoSetCountryField();
  autoSetCurrencyField();
  customiseErrorMessages();
  mobileFloatingSkipToFormButton();
  mpThumbnails();
  selectDefaultDonationAmountOnCurrencyChange();
  shareButtons();
  showDonationFrequencyOnSubmitButton();
  sideBySideElements();
  syncDonationAmountErrorState();
  syncDonationAmountLabelsWithCurrency();
  syncDonationAmountOtherBackdrop();
  validatePostcodeForCountry();
  vgsCardFieldStyles();
});
